<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 自选卡面 -->
        <div class="process01" @click="chooseOneself()">
          <div class="process_name">{{ process01 }}</div>
          <div class="process_explanation">{{ explanation01 }}</div>
          <div class="process_button">GO>>></div>
        </div>
        <!-- AI -->
        <div class="process02" @click="AICards()">
          <div class="process_name">{{ process02 }}</div>
          <div class="process_explanation">{{ explanation02 }}</div>
          <div class="process_button">GO>>></div>
        </div>
        <div class="process03" @click="semiCustomizedCards()">
          <div class="process_name">{{ process03 }}</div>
          <div class="process_explanation">{{ explanation03 }}</div>
          <div class="process_button">GO>>></div>
        </div>
        <hr />
        <div class="fixedCard">
          <div class="fixedCard_name">固定卡面</div>
          <div class="fixedCard_time">
            <div class="fixedCard_go01" @click="fixed01()">>>></div>
            <div class="fixedCard_go02" @click="fixed02()">>>></div>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
    <!-- 弹窗部分 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl.js");
const config = require("@/common/config.js");
export default {
  name: "SelectBusinessProcess",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      process01: "自选卡面",
      process02: "AI卡面",
      process03: "半定制卡面",
      explanation01: "说明：请选择您的图片  |   保持图片清晰", //制卡说明
      explanation02: "说明：AI文生图  |  AI图文生图  |  AI图生图", //制卡说明
      explanation03: "说明：业务暂未开发  |  敬请期待", //制卡说明
      errorMsg: "",
      bankSerialNumber: "",
      selectParam: "",
      bankCode: "",
    };
  },
  methods: {
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    handleOk: function (bvModalEvt) {},
    Previouspage() {
      this.$router.push({
        name: "InformationFilling",
      });
    },
    Maininterface() {
      this.$router.push({
        name: "HomePage",
      });
    },
    chooseOneself() {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.replace({
        // 自选卡面
        name: "SelectCardface_demo",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
        },
      });
      // this.errorMsg = "业务暂未开发，敬请期待";
      // this.showErrorMsg();
    },
    AICards() {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.replace({
        name: "AISelectCardface",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
        },
      });
    },
    semiCustomizedCards() {
      this.errorMsg = "业务暂未开发，敬请期待";
      this.showErrorMsg();
      //   this.$router.replace({
      //     // 半定制卡面
      //     name: "",
      //   });
    },
    fixed01() {
      this.errorMsg = "业务暂未开发，敬请期待";
      this.showErrorMsg();
    },
    fixed02() {
      this.errorMsg = "业务暂未开发，敬请期待";
      this.showErrorMsg();
    },
  },
  mounted() {
    // this.bankSerialNumber = this.$route.query.bankSerialNumber;
    // console.log("bankSerialNumber:" + this.bankSerialNumber);
    // this.radio = this.$route.query.radio;   //是否邮寄参数
    // console.log("radio:" + this.radio);
    this.bankCode = config.config_demo.bankCode;
    console.log("bankCode:" + this.bankCode);
    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.process01 {
  background: url("../../../../static/demoImage/to3.png") no-repeat center /
    cover;
  width: 100%;
  height: 8rem;
  border-radius: 0.6rem;
  margin-top: 2rem;
}
.process02 {
  background: url("../../../../static/demoImage/to2.png") no-repeat center /
    cover;
  width: 100%;
  height: 8rem;
  border-radius: 0.6rem;
  margin-top: 2rem;
}
.process03 {
  background: url("../../../../static/demoImage/to1.png") no-repeat center /
    cover;
  width: 100%;
  height: 8rem;
  border-radius: 0.6rem;
  margin-top: 2rem;
}
.process_name {
  font-size: 1.2rem;
  font-weight: 700;
}
.process_explanation {
  font-size: 0.8rem;
}
.process_button {
  width: 4rem;
  font-size: 1rem;
  font-weight: 500;
  color: white;
  background-color: black;
  text-align: center;
  border-radius: 1rem;
}
.fixedCard {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.fixedCard_name {
  font-size: 1.2rem;
  font-weight: 700;
}
.fixedCard_time {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.fixedCard_go01 {
  color: white;
  font-weight: 900;
  width: 8rem;
  height: 5rem;
  background: url("../../../../static/demoImage/公司展会DIY卡-01.png") no-repeat
    center / cover;
  border-radius: 0.6rem;
}
.fixedCard_go02 {
  color: white;
  font-weight: 900;
  width: 8rem;
  height: 5rem;
  background: url("../../../../static/demoImage/公司展会DIY卡-02.png") no-repeat
    center / cover;
  border-radius: 0.6rem;
}

/* .footer {
  background-color: blue;
  height: 3rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/SelectBusinessProcess.vue